module.exports = Auth0Lock;